<template>
<section class="notice_view">
    <div class="wrap">
        <div class="notice_view_info qna">
            <p>{{faqItem.title}}</p>
        </div>
    </div>

    <div class="notice_contents">
       {{faqItem.answer}}
    </div>
</section> 
</template>

<script>
import { mapState } from 'vuex';
    export default {
        name:'FaqInfo',
        async created () {
            this.setHeaderTitle()
            await this.getItem();
            this.$store.commit('SHOW_ONLOAD');
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapState({
                faqItem: state => state.faq.item,
            }),
            faqId(){
                return this.$route.params.faqId;
            },
        },
        methods: {
            setHeaderTitle() {
                this.$store.state.headerTitle = '자주 묻는 질문';
            },
            getItem() {
                this.$store.dispatch('GET_FAQ', this.faqId)
            }
        },
    }
</script>

<style>
.answer_dev {
    background-color: #ededed;
}
    #app {
        background:#fff
    }
    .menu_ul li {
        padding: 5px 10px;
    }
</style>